


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import NotificationBanner from '@/components/NotificationBanner/index.vue';

@Component({
  components: { NotificationBanner }
})
export default class NotificationWrapper extends Vue {
  @Prop() private notifications!: Notification[];

  @Emit('close')
  private closeNotification() {
    return;
  }
}
